export default __webpack_public_path__ + "static/media/circle-left.8fae386a.svg";